<template>
  <div v-bem="{rtl: $i18n.locale === 'ar'}">
    <div v-bem:intro class="row">
      <div class="col-6 col-m-6"><p>{{$t('steps.recap.label')}}</p></div>
      <!-- <div class="col-6 col-m-6 text-right" v-if="page !== 'recap' && canEdit">
        <button class="button button--secondary" @click="backToRecap"><span class="button__text">&#9998; {{$t('cta.edit')}}</span></button>
      </div> -->
    </div>
    <div class="list">
      <div class="item">
        <p class="heading">{{$t('steps.recap.myChoice')}}</p>
        <div v-if="page !== 'recap'" v-bem:image :style="{backgroundImage: `url(${carImage})`}"></div>
        <!-- <p class="titles">{{model.nom}}</p> -->
        <p class="titles equipements" @click="showEquipements = true">{{$t('steps.version.more-equipements')}}</p>
        <p class="detail">
          <span class="label"><strong>{{version.nom_complet}}</strong></span>
          <span class="price"><strong>{{priceFormat(version.prix)}} DHS</strong></span>
        </p>
      </div>
      <div class="item remise" v-if="version.remise">
        <p class="heading">{{$t('steps.recap.solde')}}</p>
        <p class="detail">
          <span class="label">{{$t('steps.recap.web')}}</span>
          <span class="price">- {{priceFormat(version.remise)}} DHS</span>
        </p>
      </div>
      <div class="item">
        <p class="heading">{{$t('steps.recap.exterior-design')}}</p>
        <p class="titles">{{$t('steps.color.label')}}</p>
        <p class="detail" v-if="color">
          <span class="label">{{color.couleur}}</span>
          <span class="price"><strong>{{color.code_couleur === 'blanc-glacier' ? $t('steps.color.free') : `+ ${priceFormat(color.prix)} DHS`}}</strong></span>
        </p>
        <p class="detail" v-else><span class="label">{{$t('steps.recap.noColor')}}</span></p>
      </div>
      <!-- <div v-if="optionsList.length" class="item options-list">
        <p class="heading">{{$t('steps.equipment.options')}}</p>
        <template v-if="options.length">
          <template v-for="item in options">
            <p class="detail" :key="item.id">
              <span :class="['label', {remove: step !== 5}]">
                <inline-svg v-if="step !== 5" :src="require('@/assets/img/icons/bin.svg')" @click="$store.dispatch('removeOption', item.id)"></inline-svg>
                {{item.nompack}}
              </span>
              <span class="price"><strong>+ {{priceFormat(item.prix)}} DHS</strong></span>
            </p>
          </template>
        </template>
        <div :class="['detail', {btns: step !== 5 && !accessories.length}, {space: step !== 5 && accessories.length}]">
          <span class="label" v-if="!options.length">{{$t('steps.recap.noOptions')}}</span>
          <span class="price" v-if="step !== 5">
            <button class="button button--primary" @click="showAccessories = true">
              <span class="button__text">{{$t('cta.add')}}</span>
            </button>
            <button v-if="options.length" class="button button--secondary" @click="$store.dispatch('setOptions', [])">
              <span class="button__text">{{$t('cta.reset')}}</span>
            </button>
          </span>
        </div>
      </div> -->
      <div v-if="optionsList.length" class="item options-list options-list--blue">
        <p class="heading">{{$t(!options.length ? 'steps.recap.empty-options' : 'steps.recap.options')}}</p>
        <template v-if="options.length">
          <template v-for="item in options">
            <p class="detail" :key="item.id">
              <span :class="['label', {remove: step !== 4}]">
                <inline-svg v-if="step !== 4" :src="require('@/assets/img/icons/bin.svg')" @click="$store.dispatch('removeOption', item.id)"></inline-svg>
                {{item.nomoption}}
              </span>
              <span class="price"><strong>+ {{priceFormat(item.prix)}} DHS</strong></span>
            </p>
          </template>
        </template>
        <div :class="['detail', {btns: step !== 4 && !options.length}, {space: step !== 4 && options.length}]">
          <span class="label" v-if="!options.length">
            {{$t('steps.recap.noOptions')}}
            (Becquet de toit Noir, Bavettes - Avant...)
          </span>
          <span class="price" v-if="step !== 4">
            <button class="button button--primary" @click="showOptions = true">
              <span class="button__text">{{$t('cta.add')}}</span>
            </button>
            <button v-if="options.length" class="button button--secondary" @click="$store.dispatch('setOptions', [])">
              <span class="button__text">{{$t('cta.reset')}}</span>
            </button>
          </span>
        </div>
      </div>
      <!-- <div v-if="accessoriesList.length" class="item options-list"> -->
      <div class="item options-list">
        <!-- <p class="heading">{{$t(!accessories.length ? 'steps.recap.empty-accessories' : 'steps.recap.accessories')}}</p> -->
        <!-- <template v-if="accessories.length">
          <template v-for="item in accessories">
            <p class="detail" :key="item.id">
              <span :class="['label', {remove: step !== 5}]">
                <inline-svg v-if="step !== 5" :src="require('@/assets/img/icons/bin.svg')" @click="$store.dispatch('removeAccessorie', item.id)"></inline-svg>
                {{item.nompack}}
              </span>
              <span class="price"><strong>+ {{priceFormat(item.prix)}} DHS</strong></span>
            </p>
          </template>
        </template>
        <div :class="['detail', {btns: step !== 5 && !accessories.length}, {space: step !== 5 && accessories.length}]">
          <span class="label" v-if="!accessories.length">
            {{$t('steps.recap.noAccessories')}}
            (Becquet de toit Noir, Bavettes - Avant...)
          </span>
          <span class="price" v-if="step !== 5">
            <button class="button button--primary" @click="showAccessories = true">
              <span class="button__text">{{$t('cta.add')}}</span>
            </button>
            <button v-if="accessories.length" class="button button--secondary" @click="$store.dispatch('setAccessories', [])">
              <span class="button__text">{{$t('cta.reset')}}</span>
            </button>
          </span>
        </div> -->
        <div class="detail gift">
          <span class="price"><Icon name="gift" /></span>
          <span class="label"><span>{{$t('steps.recap.hideAccessories')}}</span></span>
        </div>
      </div>
      <div class="item">
        <p class="detail">
          <span class="label">{{$t('steps.recap.costs')}}</span>
          <span class="price"><strong>+ {{priceFormat(version.frais_immat)}} DHS</strong></span>
        </p>
      </div>
      <div class="item">
        <p class="detail">
          <span class="label">{{$t('steps.recap.service')}}</span>
          <span class="price"><strong>+ {{priceFormat(version.frais_mise_en_service)}} DHS</strong></span>
        </p>
      </div>
      <div :class="['item orange', {zoom: (step < 3 && scaleBox)}]">
        <div :class="['item total', {animateColors}]">
          <p class="detail">
            <span class="label">
              {{$t('steps.recap.totalPrice')}}<br>
              <span class="small" v-if="mensualite">{{$t('steps.recap.monthlyPayment')}}</span>
            </span>
            <span class="price">
              <strong>{{priceFormat(total)}} DHS</strong>
              <span v-if="mensualite"><span class="monthly" v-if="mensualite.output">{{priceFormat(mensualite.output.mensualite_all_inclusive)}} DHS / MOIS</span></span>
            </span>
          </p>
        </div>
        <div class="detail last">
          <p class="label">{{$t('steps.recap.priceDiscounted')}}</p>
          <p class="price blur">
            <strong><span>{{hiddenPrice}}</span> DHS</strong>
          </p>
          <button class="button button--rci" @click="$emit('button-clicked')"><span class="button__text">{{$t('steps.recap.discountButton')}}</span></button>
          <p class="countdown">0{{minutes}} : {{seconds}}</p>
        </div>
      </div>
      <p class="total-text">{{$t('steps.recap.bottom_text')}}</p>
    </div>
    <AccessoriesPopin v-if="showAccessories" @close-clicked="showAccessories = false" />
    <OptionsPopin v-if="showOptions" @close-clicked="showOptions = false" />
    <EquipementsPopin v-if="showEquipements" @close-clicked="showEquipements = false" />
  </div>
</template>

<script>
import EventBus from '@/event-bus'
import InlineSvg from 'vue-inline-svg'
import { mapGetters } from 'vuex'

export default {
  props: ['page', 'step'],
  name: 'RecapBox',
  components: {
    InlineSvg,
    AccessoriesPopin: () => import('@/components/AccessoriesPopin.vue'),
    OptionsPopin: () => import('@/components/OptionsPopin.vue'),
    Icon: () => import('@/components/Icon.vue'),
    EquipementsPopin: () => import('@/components/EquipementsPopin.vue')
  },
  data: () => ({
    canEdit: true,
    showAccessories: false,
    showOptions: false,
    animateColors: false,
    scaleBox: false,
    minutes: 0,
    seconds: '59',
    showEquipements: false
  }),
  methods: {
    countDownTimer() {
      if(this.minutes >= 0) {
        if (this.seconds === '00' && this.minutes > 0) {
          this.seconds = 59;
          this.minutes -= 1;
        }
        let s = parseInt(this.seconds);
        if(s > 0) {
          setTimeout(() => {
            s -= 1;
            s = s < 10 ? '0' + s : s;
            this.seconds = s;
            this.countDownTimer();
          }, 1000);
        }
      }
    },
  },
  computed: {
		...mapGetters([
      'model',
      'version',
      'color',
      'accessoriesList',
      'optionsList',
      'accessories',
      'options',
      'mensualite',
      'total'
    ]),
    carImage() {
      return `https://www.succursalesrenault.ma/onlinestore/360ext/${this.model.nom_lien.toLowerCase()}/${this.color.code_couleur}/1.jpeg`
    },
    hiddenPrice() {
      // return this.total.toString().substring(0, 1) + ' ******';
      return '******';
    }
  },
  mounted() {
    // EventBus.$on('request-sent', () => {
    //   this.canEdit = false;
    // });
    EventBus.$on('color-selected', () => {
      this.scaleBox = false
      setTimeout(() => this.scaleBox = true, 100)
    });
    EventBus.$on('highlight-mensualite', () => {
      const top = document.querySelector('.item.total').offsetTop - 400
      window.scrollTo({ top, behavior: 'smooth' })
      this.animateColors = false
      setTimeout(() => this.animateColors = true, 200)
    });
  },
  created() {
    this.countDownTimer()
  }
}
</script>

<style scoped lang="scss">
.recap-box {
  max-width: rem(420);
  box-shadow: 0 rem(4) rem(4) rgba($black, 0.1);
  margin: 0 auto;
  .button {
    padding: 0 rem(16) rem(3);
    height: rem(38);
    min-width: initial;
    & + .button {
      margin-left: rem(8);
    }
    @include breakpoint('charmander') {
      padding: 0 rem(16);
    }
  }
  &__intro {
    padding: rem(6) rem(10);
    background-color: $dark;
    p {
      font-family: var(--primary-font-bold);
      text-transform: uppercase;
      @include font-size(18);
      color: $white;
      padding: rem(12) 0;
    }
  }
  &__image {  
    height: rem(160);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  .list {
    background-color: $gray;
    .item {
      padding: rem(16);
      margin-bottom: rem(10);
      background-color: $white;
    }
    .heading {
      font-family: var(--primary-font-bold);
      text-transform: uppercase;
      margin: rem(8) 0;
      &::after {
        content: "";
        display: block;
        width: rem(160);
        height: rem(1);
        background-color: $main-color;
        margin: rem(8) 0 rem(12);
      }
    }
    .titles {
      font-family: var(--primary-font-bold);
      @include font-size(14);
      &.equipements {
        color: $orange;
        cursor: pointer;
        margin-bottom: rem(8);
        @include font-size();
        &:hover {
          text-decoration: underline;
        }
      }
    }
    .label {
      max-width: 70%;
      display: inline-block;
      @include font-size(14);
      &.remove {
        position: relative;
        padding-left: rem(24);
        svg {
          @extend %transform-center-vertical;
          left: 0;
          width: rem(16);
          height: rem(16);
          stroke: rgba(var(--primary-color), 1);
          fill: rgba(var(--primary-color), 1);
          cursor: pointer;
          // &:hover {
          //   fill: $error-color;
          //   stroke: $error-color;
          // }
        }
      }
    }
    .detail {
      margin-bottom: rem(8);
      &.btns {
        margin: rem(16) 0 rem(24);
      }
      &.space {
        margin: rem(16) 0 rem(48);
      }
      &.gift {
        .label {
          color: rgba(var(--primary-color), 1);
          font-weight: 500;
        }
        .price {
          color: $black;
          float: left;
          margin-right: rem(20);
          .icon {
            width: rem(32);
          }
        }
      }
      &.last {
        display: inline-block;
        margin-bottom: 0;
      }
    }
    .price {
      float: right;
      @include font-size(14);
      font-family: var(--primary-font-bold);
    }
    .remise {
      background-color: $dark;
      color: $white;
      .heading {
        &::after {
          background-color: $white;
        }
      }
      .price {
        font-family: var(--primary-font-bold);
        @include font-size;
      }
    }
    .options-list {
      color: rgba(var(--primary-color), 1);
      border: rem(1) solid rgba(var(--primary-color), 1);
      .heading::after {
        background-color: rgba(var(--primary-color), 1);
      }
    }
    .total {
      background-color: $gray;
      margin-bottom: 0;
      &.animateColors {
        animation: backgroundBlink 1s;
        animation-iteration-count: 3;
      }
      .label {
        font-family: var(--primary-font-bold);
        text-transform: uppercase;
        max-width: 40%;
        padding: rem(6) 0;
        @include font-size(16);
        .small {
          display: inline-block;
          font-family: var(--primary-font);
          @include font-size(12);
          padding: rem(8) 0;
        }
      }
      .price {
        text-align: right;
        font-family: var(--primary-font-bold);
        @include font-size(28);
        .monthly {
          font-family: var(--primary-font);
          @include font-size;
          display: block;
        }
        &.barre {
          padding: rem(8) 0;
          @include font-size(20);
          text-decoration: line-through;
        }
      }
    }
    .total-text {
      display: table;
      width: 100%;
      text-align: center;
      padding: rem(16);
      @include font-size();
      font-weight: 900;
    }
    .item.orange {
      background-color: $orange;
      text-align: center;
      color: $white;
      margin: 0;
      &.zoom {
        animation: zoom 2s;
        animation-iteration-count: infinite;
      }
      .blur span {
        @include font-size(28);
        // text-shadow: 0 0 rem(12) $white;
        // color: transparent;
        // user-select: none;
      }
      .label {
        display: table;
        width: 100%;
        max-width: 100%;
        font-family: var(--primary-font-bold);
      }
      .price {
        display: table;
        width: 100%;
        @include font-size(24);
        margin: rem(16) auto;
      }
      .button.button--rci {
        border: rem(2) solid $white;
      }
      .item.total {
        background: none;
        padding: 0;
        .detail {
          text-align: left;
          margin-bottom: rem(16);
        }
        .label,
        .price {
          display: inline-block;
          width: initial;
        }
        .price {
          margin: 0;
          padding: 0;
        }
      }
      .countdown {
        @include font-size(28);
        font-weight: 700;
        margin-top: rem(8);
      }
    }
  }
  &--rtl {
    .list {
      .label {
        vertical-align: text-top;
        &.remove {
          position: relative;
          padding-left: 0;
          padding-right: rem(24);
          svg {
            @extend %transform-center-vertical;
            left: unset;
            right: 0;
          }
        }
      }
      .price {
        float: left;
        direction: ltr;
      }
    }
  }
}
@keyframes backgroundBlink { 50% { background-color: lighten($orange, 30%); }  }
@keyframes zoom { 50% { transform: scale(1.1); }  }
</style>
